import {useAuthContext} from "../../contexts/AuthContext";
import {Link, useLocation, useNavigate} from "react-router-dom";

import logo3 from "../../logo3.png";
import baseUrl from "../../baseUrl";
import {useForm} from "../../hooks/useForm";
import {useState} from "react";
import {BsEye, BsEyeSlash} from "react-icons/bs";

export const Login = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const {setLocalStorageState} = useAuthContext();
    // Р4: изходът е бил автоматичен — казва се защо, за да не изглежда като срив.
    const автоматиченИзход = location.state?.reason === "idle";
    const {values, changeHandler, onSubmitInitialValues} = useForm({
        username: "",
        password: ""
    });
    const [isChecked, setIsChecked] = useState(false)
    const [disabledButton, setDisabledButton] = useState(true)
    const [loginError, setLoginError] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const login_requester = async (data) => {

        const body = {
            username: data.username,
            password: data.password
        };


        const response = await fetch(`${baseUrl()}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        const result = await response.json();

        if (!response.ok) {
            throw result;
        }

        return result;
    }

    const onSubmitData = async (e) => {
        e.preventDefault();

        try {
            const result = await login_requester(values);

            setLoginError('');
            setLocalStorageState(result);
            onSubmitInitialValues()
            navigate("/");
        } catch (err) {
            setLoginError('Грешно потребителско име или парола.');
        }
    };

    // let disabledButton = true;
    const handleChange = () => {
        setIsChecked(!isChecked)
        setDisabledButton(!disabledButton);
    }




    return (
        <>
            <div className="d-flex justify-content-center mt-3">
                {/* Е20: логото е линк към началната страница.
                    И1: в тъмна тема — върху светла подложка (тъмнозеленият
                    надпис иначе изчезва на тъмен фон). */}
                <Link to="/" className="logoPlate" style={{maxWidth: "380px", width: "100%"}}>
                    <img style={{width: "100%", height: "auto"}} src={logo3} alt="logo"/>
                </Link>
            </div>
            {/* Ц6: целият блок е вдигнат нагоре. Логото беше mt-5 и 500 px широко
                (≈280 px високо само то), а формата тръгваше още 70 px по-долу —
                бутонът „Влез" падаше на 683 px и на лаптоп се търсеше с
                превъртане. Мерено в браузъра след промяната: 526 px. */}
            <div style={{width: "300px", margin: "auto", marginTop: "24px"}}>
                {автоматиченИзход && (
                    <div className="alert alert-warning py-2" style={{fontSize: "14px"}}>
                        Излязохте автоматично след 40 минути без действие.
                        Впишете се отново, за да продължите.
                    </div>
                )}
                <form onSubmit={onSubmitData}>
                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">Потребителско име</label>
                        <input type="text" className="form-control" id="username" name="username"
                               aria-describedby="usernameHelp" value={values.username} onChange={changeHandler}/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Парола</label>
                        {/* Бутонът „око" показва въведеното — при дълга парола на
                            непозната клавиатура иначе се гади сляпо. */}
                        <div className="input-group">
                            <input type={showPassword ? "text" : "password"} name="password"
                                   className="form-control" id="password"
                                   value={values.password} onChange={changeHandler}/>
                            <button type="button" className="btn btn-outline-secondary"
                                    onClick={() => setShowPassword(v => !v)}
                                    title={showPassword ? "Скрий паролата" : "Покажи паролата"}
                                    aria-label={showPassword ? "Скрий паролата" : "Покажи паролата"}>
                                {showPassword ? <BsEyeSlash/> : <BsEye/>}
                            </button>
                        </div>
                    </div>

                    <div className="form-check">
                        <input onChange={handleChange} className="form-check-input" type="checkbox" value=""
                               id="flexCheckDefault" checked={isChecked}/>
                        <label style={{fontSize: '14px'}} className="form-check-label" htmlFor="flexCheckDefault">
                            Приемам <Link target="_blank" to={"/terms-of-service"}>Общите условия</Link> и съм запознат/а с <Link target="_blank" to={"/privacy-policy"}>Политиката за поверителност</Link> на <strong>„APP 4 FARMERS"</strong>
                        </label>
                    </div>
                    <p className="mt-1 mb-0 text-muted" style={{fontSize: '12px'}}>
                        Фирми: вижте и <Link target="_blank" to={"/dpa"}>Споразумението за обработка на данни (DPA)</Link>.
                    </p>


                    <button type="submit" className="btn btn-secondary mt-3" disabled={disabledButton}>Влез</button>

                    {loginError && (
                        <p className="mt-2" style={{color: "var(--app-danger-fg)", fontSize: "14px"}}>{loginError}</p>
                    )}
                </form>
            </div>
        </>
    )
}